import React, { Component } from 'react';
import {
  BackToList,
  ChartHeader,
  ChartHeaderText,
  Container,
  ContainerTemperatureChart,
  DetailsContainer,
  SelectContainer,
  SerialText,
  StyledButton,
  StyledHeader,
} from './styles';
import { ArrowBack } from '@mui/icons-material';
import LoadingIndicator from '../../../../../../components/LoadingIndicator';
import DetailsTable from '../DetailsTable';
import { InputLabel, NativeSelect } from '@mui/material';
import { INTERVAL_GRAPH_POINTS } from '../shared/interval-graph-points';

class VolumeDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedInterval: INTERVAL_GRAPH_POINTS.THIRTY_MINUTES
    };
  }

  _handleIntervalChange = (e) => {
    const { serial, getTemperatureVolumeDetailsBySerial } = this.props;
    const selectedInterval = e.target.value;
    this.setState({ selectedInterval });
    getTemperatureVolumeDetailsBySerial(serial, selectedInterval);
  };

  render() {
    const {
      volumeDetailsData,
      closeDetailsLayout,
      serial,
      isLoading,
    } = this.props;
    const { selectedInterval } = this.state;

    if (isLoading) {
      return <LoadingIndicator theme="dark" text="Carregando..." />;
    }

    return (
      <Container>
        <StyledHeader>
          <BackToList>
            <StyledButton onClick={() => closeDetailsLayout()}>
              <ArrowBack />
              Voltar para a lista
            </StyledButton>
            <SerialText>{serial}</SerialText>
          </BackToList>
        </StyledHeader>
        <DetailsContainer>
          <DetailsTable volumeDetailsData={volumeDetailsData} serial={serial} />
        </DetailsContainer>
        <ContainerTemperatureChart>
          <ChartHeader>
            <ChartHeaderText>Gráfico de temperatura</ChartHeaderText>
            <SelectContainer>
              <InputLabel variant="standard">
                Exibir pontos no gráfico
              </InputLabel>
              <NativeSelect
                value={selectedInterval}
                inputProps={{
                  name: 'age',
                  id: 'uncontrolled-native',
                }}
                onChange={this._handleIntervalChange}
              >
                <option value={INTERVAL_GRAPH_POINTS.THIRTY_MINUTES}>De 30 em 30 minutos</option>
                <option value={INTERVAL_GRAPH_POINTS.TWO_HOURS}>De 2 em 2 horas</option>
                <option value={INTERVAL_GRAPH_POINTS.TWELVE_HOURS}>De 12 em 12 horas</option>
                <option value={INTERVAL_GRAPH_POINTS.ONE_DAY}>De 1 em 1 dia</option>
              </NativeSelect>
            </SelectContainer>
          </ChartHeader>
        </ContainerTemperatureChart>
      </Container>
    );
  }
}

export default VolumeDetails;
